<template>
  <div style="background-color: white; padding: 0 0 20px 0 " >
    <div class=" flex mb16 itemwrapper" style=" background: #F9F9F9; ">
        <div :class="['topitem', {'activeitem':shortCut1==='project'}]" @click.stop="shortCut('project')">项目</div>
        <div :class="['topitem1', {'activeitem':shortCut1==='person'}]"  >
          <Select id= "zoList" v-model="searchData.userAccount"  placeholder="个人" @on-change="toPerson" :label-in-value= true clearable ref="zoSelect">
            <Option value="">请选择</Option>
            <Option value="100" v-for="(item,i) in zoList" :value="item.value" :key="item.value+i">{{item.text}}</Option>
          </Select>
        </div>

      <div :class="['topitem2']" >
        <DatePicker class="block" type="daterange" style="width:100%" split-panels placeholder="时间范围" v-model="salesDate" @on-change="getSalesDate" :clearable=false :editable=false></DatePicker>
      </div>
    </div>
    <div class="charts-outer-wrapper">
      <div v-show="shortCut1==='project'" class="w2" >
        <div class="charts-wrapper" >
          <div id="answerRateCharts" :style="{width:chartsWidth+'px',height:chartHeight+'px'}" ></div>
        </div>

        <div class="charts-wrapper"  >
          <div id="followUpCharts" :style="{width:chartsWidth+'px',height:chartHeight+'px'}"></div>
        </div>

        <div class="charts-wrapper" v-if="shortCut1==='project'" >
          <div id="checkInCharts" :style="{width:chartsWidth+'px',height:chartHeight+'px'}"></div>
        </div>

      </div>
      <div v-show="shortCut1==='person'" class="w2">
        <div class="charts-wrapper2" >
          <div id="answerRateCharts2" :style="{width:chartsWidth2+'px',height:chartHeight2+'px'}" ></div>
        </div>

        <div class="charts-wrapper2" >
          <div id="followUpCharts2" :style="{width:chartsWidth2+'px',height:chartHeight2+'px'}"></div>
        </div>

      </div>

    </div>
        <div style="padding-left: 25px;padding-top: 10px">
      <div class="unoccupied-wrapper">
        <div class="wrapper">
          <div class="item-left">商机量 :</div>
          <div class="item-right">{{salesData.businessCount}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left">客源量 :</div>
          <div class="item-right">{{salesData.customerCount}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left">带看量 :</div>
          <div class="item-right">{{salesData.visitCount}}</div>
        </div>
      </div>
      <div class="unoccupied-wrapper" style="padding-top: 10px">
        <div class="wrapper">
          <div class="item-left">新签量 :</div>
          <div class="item-right">{{salesData.newSignCount}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left">解约量 :</div>
          <div class="item-right">{{salesData.surrentCount}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left">续约量 :</div>
          <div class="item-right">{{salesData.renewCount}}</div>
        </div>
      </div>
      <div class="unoccupied-wrapper" style="padding-top: 10px">
        <div class="wrapper">
          <div class="item-left">直播商机量 :</div>
          <div class="item-right">{{salesData.liveBusinessNum}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left">直播客源量 :</div>
          <div class="item-right">{{salesData.liveBusinessCustomNum}}</div>
        </div>
        <div class="wrapper">
          <div class="item-left" style="text-align: center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/pie')
  require("echarts/lib/component/legend");
  require("echarts/lib/component/tooltip");
  require('echarts/theme/macarons');
  import {getProjectZos } from 'api/common'
  import { querySaleKanBanCount,queryFlowRateAndCheckInRate,queryAnswerRate} from 'api/workBench'

  export default {
    name: "Sales",
    components: {
    },
    watch: {
      projectFid(val){
        if(val){
          getProjectZos(val).then( res => {
            this.zoList = res.data
          })
          this.getSalesShowData()
        }
      },
    },
    computed:{
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        shortCut1: 'project',
        salesDate:[],
        searchData: {
          operatorId: "11",
          userAccount: "",
          zoName: "",
          startDate: '',
          endDate: '',
          pageNum: 0,
          pageSize: 0
        },
        //临时变量
        zoList:[],
        answerRateData: [],
        followUpRateData: [],
        checkInRateData: [],
        salesData: {
          businessCount:'',
          customerCount:'',
          visitCount:'',
          newSignCount:'',
          surrentCount:'',
          renewCount:'',
          liveBusinessNum: '',
          liveBusinessCustomNum: '',
          liveFlowRate: ''
        },
        chartsWidth: 0,
        chartHeight: 0,
        chartsWidth2:0,
        chartHeight2: 0,
      }
    },
    methods: {
      toPerson(value){
         if(!value.value){
           this.shortCut('project')
           this.searchData.userAccount = value.value;
         }else {
             //console.log(value.value+"********"+value.label);
           this.searchData.userAccount = value.value;
           this.searchData.zoName = value.label;
           this.shortCut('person')
         }

      },

      //接听率
      setAnswerRate() {

       if (this.answerRateData.length === 0) {
          return;
        }
        const id=this.shortCut1==='project'?'answerRateCharts':'answerRateCharts2'
        const e2 = echarts.init(document.getElementById(id),'macarons');
        const option = {
          title : {
            text: '接听率',
            x:this.shortCut1==='project'?'35%':'40%',
            bottom:20,
            textStyle: {
              fontSize: '12',
              fontWeight: 'normal',
              color:'#495060'
            },
          },
          series: [
            {
              // center: ['45%', '45%'],
              legendHoverLink:false,
              hoverAnimation:false,
              name: '',
              type: 'pie',
              radius: this.shortCut1==='project'?['40%', '50%']:['30%','40%'],
              data: this.answerRateData,
              avoidLabelOverlap: false,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'center',
                  textStyle: {
                    fontSize: '10',
                    fontWeight: 'normal',
                    color:'#495060'
                  },
                  formatter:function (param) {
                      return param.name=='接听率'?(param.value*100).toFixed(2)+'%':'';
                  }
                }
              },
            }
          ],
          color:['#F2BA49', '#DFDFDF']

        }
        e2.clear()
        e2.setOption(option)
      },
      //跟进率
      setFollowUpRate() {
        if (this.followUpRateData.length === 0) {
          return
        }
        const id=this.shortCut1==='project'?'followUpCharts':'followUpCharts2'
        const e2 = echarts.init(document.getElementById(id),'macarons');
        const option = {
          title : {
            text: '及时跟进率',
            x:this.shortCut1==='project'?'30%':'35%',
            bottom:20,
            textStyle: {
              fontSize: '12',
              fontWeight: 'normal',
              color:'#495060'
            },
          },
          series: [
            {
              center: ['50%', '50%'],
              legendHoverLink:false,
              hoverAnimation:false,
              name: '',
              type: 'pie',
              radius: this.shortCut1==='project'?['40%', '50%']:['30%','40%'],
              data: this.followUpRateData,
              avoidLabelOverlap: false,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'center',
                  textStyle: {
                    fontSize: '10',
                    fontWeight: 'normal',
                    color:'#495060'
                  },
                  formatter:function (param) {
                    return param.name=='及时跟进率'?(param.value*100).toFixed(2)+'%':'';
                  }
                }
              },


            }
          ],
          color:['#F2BA49', '#DFDFDF']

        }
        e2.clear()
        e2.setOption(option)
      },
      //入住率
      setCheckInRate() {
        if (this.checkInRateData.length === 0) {
          return
        }
        const e2 = echarts.init(document.getElementById('checkInCharts'),'macarons');
        const option = {
          title : {
            text: '入住率',
            x:'35%',
            bottom:20,
            textStyle: {
              fontSize: '12',
              fontWeight: 'normal',
              color:'#495060'
            },
          },
          series: [
            {
              // center: ['45%', '45%'],
              legendHoverLink:false,
              hoverAnimation:false,
              name: '',
              type: 'pie',
              radius: ['40%', '50%'],
              data: this.checkInRateData,
              avoidLabelOverlap: false,
              labelLine: {
                normal: {
                  show: false
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'center',
                  textStyle: {
                    fontSize: '10',
                    fontWeight: 'normal',
                    color:'#495060'
                  },
                  formatter:function (param) {
                    return param.name=='入住率'?(param.value*100).toFixed(2)+'%':'';
                  }
                }
              },
            }
          ],
          color:['#F2BA49', '#DFDFDF']

        }
        e2.clear()
        e2.setOption(option)
      },
      setWH() {
        // this.chartsWidth=0
        // this.$nextTick(()=>{
          const w1 = document.getElementsByClassName('charts-wrapper')
          if (w1.length > 0) {
            const h1 = w1[0]
            this.chartHeight = Number(window.getComputedStyle(h1).height.slice(0, -2))
            this.chartsWidth = Number(window.getComputedStyle(h1).width.slice(0, -2))

          }
        const w2 = document.getElementsByClassName('charts-wrapper2')
        if (w2.length > 0) {
          const h2 = w2[0]
          this.chartHeight2 = Number(window.getComputedStyle(h2).height.slice(0, -2))
          this.chartsWidth2 = Number(window.getComputedStyle(h2).width.slice(0, -2))

        }

      },
      shortCut(value) {
          if(value=='project') {
            this.$refs.zoSelect.clearSingleSelect();
            this.searchData.zoName = ''
          }
        this.shortCut1 = value;
        this.$nextTick(()=>{
          this.getSalesShowData();
        })
      },
      getSalesShowData() {
        this.$nextTick(()=>{
          this.setWH();
          this.$nextTick(()=>{
            if(!this.projectFid) {
              return;
            }
            const params = {
              ...this.searchData,
              projectFid:this.projectFid,
            };

            querySaleKanBanCount(params).then(res=>{
              if(res.data) {
                this.salesData.businessCount = res.data.businessNum;
                this.salesData.customerCount = res.data.businessCustomNum;
                this.salesData.newSignCount = res.data.signNum;
                this.salesData.renewCount = res.data.renewNum;
                this.salesData.surrentCount = res.data.surrenderNum;
                this.salesData.visitCount = res.data.lookNum;
                this.salesData.liveBusinessNum = res.data.liveBusinessNum;
                this.salesData.liveBusinessCustomNum = res.data.liveBusinessCustomNum;
                this.salesData.liveFlowRate = (parseFloat(res.data.liveFlowRate) * 100).toFixed(2) + '%';
              }
            }).catch(() => { });
            queryFlowRateAndCheckInRate(params).then(res=>{
              if(res.data) {
                if(this.followUpRateData&&this.followUpRateData.length>0) {
                  this.followUpRateData.splice(0,this.followUpRateData.length);
                }
                if(this.checkInRateData&&this.checkInRateData.length>0) {
                  this.checkInRateData.splice(0,this.checkInRateData.length);
                }
                res.data.forEach((ele)=>{
                  if(ele.type == 2){
                    this.followUpRateData.push(ele);
                  }else if (ele.type == 3){
                    this.checkInRateData.push(ele);
                  }
                })

              }
              this.setFollowUpRate();
              if(this.shortCut1==='project') {
                this.setCheckInRate();
              }
            }).catch(() => {});

            queryAnswerRate(params).then(res=>{
              if(res.data) {
                if(this.answerRateData&&this.answerRateData.length>0) {
                  this.answerRateData.splice(0,this.answerRateData.length);
                }
                this.answerRateData=(res.data);
              }
              this.setAnswerRate();
            }).catch(() => {});
          })
        })

      },

      initData() {
        this.salesDate = [new Date(),new Date()]
        this.searchData.startDate = new Date();
        this.searchData.endDate = new Date();
      },

      getSalesDate(value) {
        this.searchData.startDate = value[0];
        this.searchData.endDate = value[1];
        this.getSalesShowData();
      }
    },
    created() {
      if(this.projectFid){
        getProjectZos(this.projectFid).then( res => {
          this.zoList = res.data
        })
      }
    },

    mounted() {
      this.initData();
      this.getSalesShowData();
    }
  }
</script>

<style scoped>
  .charts-outer-wrapper{
    width: 100%;
    height:200px ;

  }
  .w2{
    width: 100%;
    height: 100%;
    display: flex;
  }
  .topitem{
    display: inline-block;
    width: 90px;
    text-align: center;
    line-height: 32px;
    padding: 10px ;
    flex: none;
  }
  .topitem1{
    display: inline-block;
    width: 120px;
    text-align: center;
    /*line-height: 2.2;*/
    padding: 10px;
    flex: none;
  }
  .topitem2{
    /*width: 300px;*/
    text-align: center;
    line-height: 2.2;
    padding: 10px ;
    flex: auto;
  }
  .activeitem{
    background: white;
  }

  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #f9f9f9;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px ;
    box-sizing: border-box;
  }



  .color0{
    background-color: rgb(189,226,184);
  }
  .color1{
    background-color: rgb(168,217,161);

  }
  .color2{
    background-color: rgb(143,201,135);
  }
  .color3{
    background-color: rgb(17,152,105);
  }
  .part1 li {
    margin-top: -1px;
    display: flex;
  }

  .vname, .vvalue {
    flex: 1;
    display: inline-block;
    /*width: 90px;*/
    border: 1px solid lightgray;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }

  .vvalue {
    margin-left: -1px;
  }

  .part1 {
    flex: 0.35;
    /*background-color: lightsteelblue;*/
  }

  .part2 {
    flex: .65;
    /*background-color: lightcyan;*/
  }

  .unoccupied-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    font-size: 12px;
    color:#495060;
    display: flex;

    /*background-color: lightpink;*/
  }

  .item-left {
    width: 50%;
    /* float: left; */
    text-align: right;
  }

  .item-right {
    width: 50%;
    /* float: right; */
    text-align: left;
    padding-left: 5px;
  }

  .charts-wrapper{
    flex: 1;
    height: 200px;
  }
  .charts-wrapper2{
    flex: 1;

    height: 200px;
  }
</style>
